import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"


import { ref } from 'vue'
import { addBiScore, updateBiScore } from '@/api/overseasSales/businessRuleSetting'
import type { FormInstance } from 'ant-design-vue'
import { AddBiScoreParams } from '@/typings/api/overseasSales'
import CusSelect from '@/components/CustomerCodeSelect/index.vue'
import { DcMessage } from '@dc-platform/dc-components'
import { useI18n } from 'vue-i18n'

const __default__ = { name: 'editModal' }

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  emits: ['success'],
  setup(__props, { expose: __expose, emit: __emit }) {

const { t } = useI18n()
const visible = ref<boolean>(false)
const loading = ref<boolean>(false)
const formRef = ref<FormInstance>()
const editForm = ref<AddBiScoreParams>({})
const emit = __emit
const toggle = (row?: AddBiScoreParams) => {
  visible.value = !visible.value
  if (row && row.id) {
    editForm.value = { ...row }
  } else {
    editForm.value = {}
  }
}
const selectData = (value: string) => {
  editForm.value.cosId = value
}
const handleSubmit = () => {
  formRef.value?.validate().then(async () => {
    loading.value = true
    const { arkCode, cosId, score, id } = editForm.value
    const p = {
      arkCode,
      cosId,
      score
    }
    try {
      if (editForm.value.id) {
        await updateBiScore({ ...p, id: editForm.value.id })
      } else {
        await addBiScore(p)
      }
      loading.value = false
      emit('success', editForm.value?.id ? 'edit' : 'add')
      DcMessage.success(editForm.value?.id ? t('operate.mmet2b') : t('operate.ywoekr'))
      toggle()
    } catch (error) {
      loading.value = false
    }
  })
}
__expose({
  toggle
})

return (_ctx: any,_cache: any) => {
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_cos_modal = _resolveComponent("cos-modal")!
  const _directive_trim = _resolveDirective("trim")!

  return (_openBlock(), _createBlock(_component_cos_modal, {
    visible: visible.value,
    "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((visible).value = $event)),
    title: editForm.value.id ? _unref(t)('btn.edit') : _unref(t)('btn.add'),
    width: "600px",
    onOk: handleSubmit,
    confirmLoading: loading.value
  }, {
    default: _withCtx(() => [
      (visible.value)
        ? (_openBlock(), _createBlock(_component_a_form, {
            key: 0,
            model: editForm.value,
            ref_key: "formRef",
            ref: formRef,
            autocomplete: "off"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_form_item, {
                name: "arkCode",
                label: _unref(t)('operate.6rj8gj'),
                rules: [{ required: true, message: _unref(t)('common.pleaseSelect') }]
              }, {
                default: _withCtx(() => [
                  _createVNode(CusSelect, {
                    appId: "cos_ofbu",
                    value: editForm.value.arkCode,
                    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((editForm.value.arkCode) = $event)),
                    onSelectData: selectData
                  }, null, 8, ["value"])
                ]),
                _: 1
              }, 8, ["label", "rules"]),
              _createVNode(_component_a_form_item, {
                name: "score",
                label: _unref(t)('operate.9bijib'),
                rules: [{ required: true, message: _unref(t)('common.pleaseInput') }]
              }, {
                default: _withCtx(() => [
                  _withDirectives(_createVNode(_component_a_input, {
                    value: editForm.value.score,
                    "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((editForm.value.score) = $event)),
                    maxlength: 10,
                    precision: 0,
                    placeholder: _unref(t)('common.pleaseInput')
                  }, null, 8, ["value", "placeholder"]), [
                    [_directive_trim]
                  ])
                ]),
                _: 1
              }, 8, ["label", "rules"])
            ]),
            _: 1
          }, 8, ["model"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["visible", "title", "confirmLoading"]))
}
}

})